import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Switch, Text, HStack } from '@chakra-ui/react';

const STORAGE_KEY = 'useTestData';

const TestDataToggle = () => {
  const location = useLocation();
  const [useTestData, setUseTestData] = useState(false);

  // Load toggle state on mount
  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    setUseTestData(stored === 'true');
  }, []);

  const handleToggle = () => {
    const newState = !useTestData;
    setUseTestData(newState);
    sessionStorage.setItem(STORAGE_KEY, newState.toString());

    // Update URL parameters
    const params = new URLSearchParams(location.search);
    if (newState) {
      params.set('test', 'true');
    } else {
      params.delete('test');
    }

    const newUrl = `${location.pathname}${params.toString() ? `?${params.toString()}` : ''}`;
    window.location.replace(newUrl); // 🔄 Force hard reload
  };

  return (
    <HStack spacing={2} align="center">
      <Text fontWeight={useTestData ? 'normal' : 'bold'}>LIVE DATA</Text>
      <Switch
        isChecked={useTestData}
        onChange={handleToggle}
        colorScheme="teal"
        size="md"
      />
      <Text fontWeight={useTestData ? 'bold' : 'normal'}>TEST DATA</Text>
    </HStack>
  );
};

export default TestDataToggle;
